(function () {
  var selector = '[data-am2pm-deferred-reviews]';
  var events = ['pointerdown', 'keydown', 'touchstart', 'scroll'];

  function activate() {
    events.forEach(function (eventName) {
      window.removeEventListener(eventName, activate);
    });

    document.querySelectorAll(selector).forEach(function (container) {
      if (container.dataset.reviewsLoaded === 'true') return;

      var widget = document.createElement('div');
      widget.className = container.dataset.widgetClass;
      container.dataset.reviewsLoaded = 'true';
      container.appendChild(widget);
    });
  }

  events.forEach(function (eventName) {
    window.addEventListener(eventName, activate, { once: true, passive: true });
  });
})();
